module.exports = __webpack_public_path__ + "media/SERF25-0900-Generative_AI.22bf393d.mp4";